import React             from 'react';
import View              from '@widesk-ui/components/View';
import SliderInputNumber from '@/TokamapEditor/ux/AreaSidebar/SliderInputNumber';
import { InputNumberProps } from '@widesk-ui/components/form/InputNumber';
import useDesignTokens   from '@/hooks/useDesignTokens';

export default function SliderInputNumberFeature({
	value,
	loading,
	isPercent,
	mixed,
	onChange,
	onAfterChange,
	onStartChange,
	inputProps,
	resetValue,
	unitSelect,
}: {
	value: number;
	loading: boolean;
	isPercent?: boolean;
	mixed?: boolean;
	onStartChange?: () => void;
	onChange?: (value: number) => void;
	onAfterChange: (value: number) => void;
	inputProps?: Partial<InputNumberProps>;
	resetValue?: number;
	unitSelect?: React.ComponentProps<typeof SliderInputNumber>['unitSelect'];
}) {
	const [started, setStarted] = React.useState(false);
	const tokens = useDesignTokens();

	return (
		<View gap={4}>
			<SliderInputNumber
				loading={loading}
				value={value}
				resetValue={resetValue}
				unitSelect={unitSelect}
				onAfterChange={async value => {
					if (started) {
						setStarted(false);
					}

					if (value !== null && value !== undefined && onAfterChange) {
						onAfterChange(value);
					}
				}}

				{...(() => {
					if (isPercent) {
						return { min: 0, max: 100, suffix: '%', step: 1 };
					}

					return {};
				})()}

				{...inputProps as any}

				onChange={v => {
					if (!started && onStartChange) {
						setStarted(true);
						onStartChange?.();
					}

					onChange?.(v as number);
				}}
			/>

			{mixed && (
				<View size={12} color={tokens.text.muted}>
					Valeurs différentes
				</View>
			)}
		</View>
	);
}